const selector = "#ProductGridContainer";
let cacheManager = {};

window.addEventListener('pageshow', function (e) {
    onLoad(e);
});

function onLoad(e) {
    cacheManager = new PageCacheManager(
        {
            bodySelector: selector,
            onLoaded: onLoadedCache,
            onCached: onCachedCache,
        }
    );

    if (!e.persisted) {
        document.addEventListener('click', function (e) {
            const closest = e.target.closest('.product-loop .card-wrapper a');
            if (closest) cacheManager.cachePage();
        });
    }
}

function infiniteScrollCollection() {
    var endlessScroll = new Ajaxinate({
        container: '.product-loop',
        pagination: '#CollectionPagination',
        method: 'scroll',
        loadingText: '',
        offset: 0
    });
}

function onLoadedCache(e) {
    console.log('loaded');
    infiniteScrollCollection();
    document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e) {
    console.log('cached');
};